var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarInformation2White(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.28 2.16021H13.68V1.08021C13.68 0.984737 13.6421 0.893169 13.5746 0.825656C13.507 0.758143 13.4155 0.720215 13.32 0.720215C13.2245 0.720215 13.133 0.758143 13.0654 0.825656C12.9979 0.893169 12.96 0.984737 12.96 1.08021V2.16021H5.04V1.08021C5.04 0.984737 5.00207 0.893169 4.93456 0.825656C4.86705 0.758143 4.77548 0.720215 4.68 0.720215C4.58452 0.720215 4.49295 0.758143 4.42544 0.825656C4.35793 0.893169 4.32 0.984737 4.32 1.08021V2.16021H0.72C0.529044 2.16021 0.345909 2.23607 0.210883 2.3711C0.0758569 2.50612 0 2.68926 0 2.88021L0 17.2802C0 17.4712 0.0758569 17.6543 0.210883 17.7893C0.345909 17.9244 0.529044 18.0002 0.72 18.0002H17.28C17.471 18.0002 17.6541 17.9244 17.7891 17.7893C17.9241 17.6543 18 17.4712 18 17.2802V2.88021C18 2.68926 17.9241 2.50612 17.7891 2.3711C17.6541 2.23607 17.471 2.16021 17.28 2.16021ZM17.28 17.2802H0.72V6.48022H17.28V17.2802ZM17.28 5.76021H0.72V2.88021H17.28V5.76021Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36001 10.8003H8.64001V15.1203H9.36001V10.8003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36001 9.36035H8.64001V10.0804H9.36001V9.36035Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarInformation2White);
export default __webpack_public_path__ + "static/media/calendar-information.2-white.ece98bc9dcde3d255bb745109951d70a.svg";
export { ForwardRef as ReactComponent };